export default __webpack_public_path__ + "static/driver-partners-mounted-phone-61680cb7d067afbe6dee8da581d7d082.png";